(()=>{
'use strict';
if(window.__AXION_BUILD_SHARE_CART_DEV_V4__)return;
window.__AXION_BUILD_SHARE_CART_DEV_V4__=true;

const FULL_TOKEN_RE=/AXS1-[A-Za-z0-9_-]{15}/i;
const PUBLIC_CODE_RE=/AX5-R(?:0|2|4)-BT[1-3]-(?:GF|GK|KS)-[A-Z0-9]{3}-S1-[A-Za-z0-9_-]{15}/i;
const SHORT_CODE_RE=/AX5-R(?:0|2|4)-BT[1-3]-(?:GF|GK|KS)-[A-Z0-9]{3}/i;
const ROOT_SELECTOR='[data-axion-configurator][data-product-handle="axion-designer-ps5"]';
const PAYLOAD_KEY_PREFIX='AXION_CART_PAYLOAD_V1:';

const hasFullShareInput=value=>{
  const raw=String(value||'').trim();
  if(!raw)return false;
  if(FULL_TOKEN_RE.test(raw)||PUBLIC_CODE_RE.test(raw))return true;
  try{const decoded=decodeURIComponent(raw);return FULL_TOKEN_RE.test(decoded)||PUBLIC_CODE_RE.test(decoded)}catch(_){return false}
};
const shortBuildCode=value=>String(value||'').match(SHORT_CODE_RE)?.[0]?.toUpperCase()||'';

const updateImportCopy=()=>{
  document.querySelectorAll('[data-axion-import-form]').forEach(form=>{
    const label=form.querySelector('label');
    const input=form.querySelector('input');
    const status=form.querySelector('[data-axion-import-status]');
    if(label)label.textContent='CODICE CONDIVISIONE';
    if(input)input.placeholder='Incolla qui il codice completo';
    if(status&&!status.classList.contains('is-error'))status.textContent='';
  });
};

document.addEventListener('submit',event=>{
  const form=event.target?.closest?.('[data-axion-import-form]');
  if(!form)return;
  const input=form.querySelector('input');
  const raw=input?.value||'';
  if(hasFullShareInput(raw)||!shortBuildCode(raw))return;
  event.preventDefault();event.stopPropagation();event.stopImmediatePropagation();
  const status=form.querySelector('[data-axion-import-status]');
  if(status){status.classList.add('is-error');status.textContent='Incolla il codice condivisione completo.'}
  input?.focus();
},true);

const currentPayload=()=>{
  const root=document.querySelector(ROOT_SELECTOR);
  if(!root)return null;
  try{const payload=JSON.parse(root.querySelector('.axv3__payload pre')?.textContent||'');return payload&&typeof payload==='object'?payload:null}catch(_){return null}
};

const nativeFetch=window.fetch;
if(typeof nativeFetch==='function'&&!window.__AXION_SHARE_FETCH_WRAPPED_V4__){
  window.__AXION_SHARE_FETCH_WRAPPED_V4__=true;
  window.fetch=function(input,init){
    let nextInit=init;
    try{
      const url=typeof input==='string'?input:input?.url||'';
      if(/\/cart\/add\.js$/i.test(new URL(url,window.location.origin).pathname)&&typeof init?.body==='string'){
        const body=JSON.parse(init.body);
        const controller=Array.isArray(body?.items)?body.items.find(item=>item?.properties?._axion_role==='controller'):null;
        const api=window.AXION_SHARE_CONFIG;
        const payload=currentPayload();
        if(controller&&payload&&api?.encode&&api?.publicCode){
          const token=api.encode(payload);
          controller.properties={...(controller.properties||{}),_axion_share_code:api.publicCode(payload,token)};
          nextInit={...init,body:JSON.stringify(body)};
        }
      }
    }catch(error){console.warn('[AXION share/cart DEV] Impossibile allegare il codice condivisione al carrello.',error)}
    return nativeFetch.call(this,input,nextInit);
  };
}

const parseProperties=group=>{
  try{const raw=JSON.parse(group.querySelector('[data-cart-config-properties]')?.textContent||'{}');return Array.isArray(raw)?Object.fromEntries(raw.filter(item=>Array.isArray(item)&&item.length>=2)):raw}catch(_){return {}}
};
const cartShareCode=group=>{
  const stored=String(parseProperties(group)?._axion_share_code||'').trim();
  if(PUBLIC_CODE_RE.test(stored))return stored.match(PUBLIC_CODE_RE)[0];
  const id=group.dataset.axionPreviewId||'';
  let payload=null;
  try{payload=JSON.parse(localStorage.getItem(`${PAYLOAD_KEY_PREFIX}${id}`)||'null')}catch(_){}
  const api=window.AXION_SHARE_CONFIG;
  if(!payload||typeof payload!=='object'||!api?.encode||!api?.publicCode)return '';
  try{const token=api.encode(payload);return api.publicCode(payload,token)}catch(error){console.warn('[AXION share/cart DEV] Codice completo non disponibile per questa build.',error);return ''}
};

let copyField=null;
const copyTextFast=value=>{
  const text=String(value||'');
  if(!text)throw new Error('Codice non disponibile');
  if(!copyField){
    copyField=document.createElement('textarea');
    copyField.setAttribute('readonly','');copyField.setAttribute('aria-hidden','true');copyField.tabIndex=-1;
    copyField.style.cssText='position:fixed;left:-10000px;top:0;width:1px;height:1px;opacity:0;pointer-events:none';
    document.body.appendChild(copyField);
  }
  copyField.value=text;
  try{copyField.focus({preventScroll:true})}catch(_){copyField.focus()}
  copyField.select();
  try{copyField.setSelectionRange(0,text.length)}catch(_){}
  try{return document.execCommand?.('copy')===true}catch(_){return false}
};
const copyText=value=>{
  const text=String(value||'');
  if(!text)return Promise.reject(new Error('Codice non disponibile'));
  if(copyTextFast(text))return Promise.resolve();
  if(navigator.clipboard?.writeText)return navigator.clipboard.writeText(text);
  return Promise.reject(new Error('Copia non disponibile'));
};
const setReviewStatus=(card,message,error=false)=>{
  const status=card?.querySelector('[data-axion-share-status]');
  if(!status)return;status.textContent=message;status.classList.toggle('is-error',error);
};
const flashCopied=(button,label='COPIATO ✓',delay=950)=>{
  const original=button.textContent;button.textContent=label;window.setTimeout(()=>{button.textContent=original},delay);
};

const installStyle=()=>{
  if(document.getElementById('axion-build-share-cart-dev-style'))return;
  const style=document.createElement('style');style.id='axion-build-share-cart-dev-style';
  style.textContent=`
    .ax-cart-v2 .axc-code.axc-code-with-copy{display:flex!important;align-items:center;flex-wrap:wrap;gap:9px}
    .ax-cart-v2 .axc-copy-build,.ax-cart-v2 .axc-share-copy{min-height:28px;padding:0 10px;border:1px solid rgba(216,255,62,.34);border-radius:999px;background:rgba(216,255,62,.075);color:#d8ff3e;font:950 8px/1 Arial,sans-serif;letter-spacing:.055em;text-transform:uppercase;cursor:pointer}
    .ax-cart-v2 .axc-share-row{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:14px 15px;border-top:1px solid rgba(255,255,255,.08);background:#09111b}
    .ax-cart-v2 .axc-share-copy-block{display:grid;gap:6px;min-width:0}.ax-cart-v2 .axc-share-copy-block span{color:#6f7d90;font:900 9px/1 Arial,sans-serif;letter-spacing:.09em;text-transform:uppercase}
    .ax-cart-v2 .axc-share-copy-block code{color:#d8ff3e;font:900 11px/1.35 ui-monospace,SFMono-Regular,Consolas,monospace;overflow-wrap:anywhere;word-break:break-word}
    [data-axion-import-form] input{color:#f8f8f3!important;-webkit-text-fill-color:#f8f8f3!important;font-weight:800!important}[data-axion-import-form] input::placeholder{color:rgba(226,235,246,.72)!important;-webkit-text-fill-color:rgba(226,235,246,.72)!important;opacity:1!important}
    [data-axion-import-form] [data-axion-import-status]:empty{display:none!important}[data-axion-import-form] [data-axion-import-status].is-error{color:#ff5f5f!important;-webkit-text-fill-color:#ff5f5f!important}
    .axion-import-build-highlight{color:#d8ff3e!important;-webkit-text-fill-color:#d8ff3e!important;font-weight:950!important;text-shadow:0 0 14px rgba(216,255,62,.18)}
    .axv3 [data-axion-share-card] [data-axion-share-native]{display:none!important}.axv3 [data-axion-share-card] .axv3__share-actions{grid-template-columns:1fr!important}
    .axv3 [data-axion-share-card] [data-axion-share-link]{min-height:40px!important;border:1px solid #d8ff3e!important;background:#d8ff3e!important;color:#07100a!important;font:950 9px/1 Arial,sans-serif!important;letter-spacing:.07em!important}
    @media(max-width:720px){.ax-cart-v2 .axc-share-row{align-items:stretch;flex-direction:column}.ax-cart-v2 .axc-share-copy{width:100%;min-height:34px}}
  `;
  document.head.appendChild(style);
};

const normalizedText=el=>(el?.textContent||'').trim().replace(/\s+/g,' ');
const highlightImportBuildTrigger=()=>{
  document.querySelectorAll('[data-axion-import-form]').forEach(form=>{
    const scope=form.parentElement?.parentElement||form.parentElement;if(!scope)return;
    const target=[scope,...scope.querySelectorAll('a,button,span,p,div')].find(el=>el.dataset?.axionImportStyled!=='1'&&normalizedText(el)==='HAI UN CODICE? IMPORTA BUILD'&&![...el.children].some(child=>normalizedText(child)==='HAI UN CODICE? IMPORTA BUILD'));
    if(!target)return;target.dataset.axionImportStyled='1';target.innerHTML='HAI UN CODICE? <span class="axion-import-build-highlight">IMPORTA BUILD</span>';
  });
};

const simplifyReviewShareCopy=()=>{
  document.querySelectorAll('[data-axion-share-card]').forEach(card=>{
    const shareButton=card.querySelector('[data-axion-share-link]');const nativeButton=card.querySelector('[data-axion-share-native]');const actions=card.querySelector('.axv3__share-actions');const status=card.querySelector('[data-axion-share-status]');
    if(nativeButton)nativeButton.hidden=true;if(actions)actions.classList.add('is-single');
    if(shareButton){shareButton.textContent='CONDIVIDI BUILD';shareButton.setAttribute('aria-label','Condividi build');shareButton.title='Copia il link di questa configurazione'}
    if(status&&!status.classList.contains('is-error')){const current=(status.textContent||'').trim();if(!current||current==='Il codice completo include tutte le selezioni. Il prezzo viene sempre ricalcolato da Axion.')status.textContent='Il link apre direttamente questa configurazione.'}
  });
};

const enhanceCart=()=>{
  const groups=document.querySelectorAll('.ax-cart-v2 [data-cart-group][data-axion-preview-id]');if(!groups.length)return;
  groups.forEach(group=>{
    if(group.dataset.axionShareEnhanced==='1')return;const shareCode=cartShareCode(group);if(!shareCode)return;
    group.dataset.axionShareEnhanced='1';group.dataset.axionShareCode=shareCode;
    const shortCode=group.querySelector('.axc-code');
    if(shortCode&&!shortCode.querySelector('[data-axion-copy-build]')){shortCode.classList.add('axc-code-with-copy');const button=document.createElement('button');button.type='button';button.className='axc-copy-build';button.dataset.axionCopyBuild='';button.textContent='COPIA BUILD';button.title='Copia il codice completo di condivisione';shortCode.appendChild(button)}
    const details=group.querySelector('.axc-config');
    if(details&&!details.querySelector('[data-axion-share-row]')){const row=document.createElement('div');row.className='axc-share-row';row.dataset.axionShareRow='';const block=document.createElement('div');block.className='axc-share-copy-block';const label=document.createElement('span');label.textContent='CODICE CONDIVISIONE';const code=document.createElement('code');code.textContent=shareCode;block.append(label,code);const button=document.createElement('button');button.type='button';button.className='axc-share-copy';button.dataset.axionShareCopy='';button.textContent='COPIA';row.append(block,button);details.appendChild(row)}
  });
};

/* Review: COPIA CODICE -> copia immediata, senza attendere UI di sistema. */
document.addEventListener('click',event=>{
  const button=event.target?.closest?.('[data-axion-share-card] [data-axion-share-code]');if(!button)return;
  const card=button.closest('[data-axion-share-card]');const code=String(card?.dataset.axionShareCode||card?.querySelector('.axv3__share-code code')?.textContent||'').trim();if(!card||!code)return;
  event.preventDefault();event.stopPropagation();event.stopImmediatePropagation();
  try{if(copyTextFast(code)){flashCopied(button);setReviewStatus(card,'Codice copiato.');return}}catch(_){}
  button.textContent='COPIA…';
  if(navigator.clipboard?.writeText){navigator.clipboard.writeText(code).then(()=>{button.textContent='COPIATO ✓';setReviewStatus(card,'Codice copiato.');window.setTimeout(()=>{button.textContent='COPIA CODICE'},950)}).catch(error=>{button.textContent='COPIA CODICE';setReviewStatus(card,error?.message||'Copia non disponibile.',true)})}
  else{button.textContent='COPIA CODICE';setReviewStatus(card,'Copia non disponibile.',true)}
},true);

/* CONDIVIDI BUILD -> copia subito il link. Niente finestra Windows / navigator.share. */
document.addEventListener('click',event=>{
  const button=event.target?.closest?.('[data-axion-share-card] [data-axion-share-link]');if(!button)return;
  const card=button.closest('[data-axion-share-card]');const token=card?.dataset.axionShareToken||'';const api=window.AXION_SHARE_CONFIG;if(!card||!token||!api?.link)return;
  event.preventDefault();event.stopPropagation();event.stopImmediatePropagation();const url=api.link(token);
  try{if(copyTextFast(url)){flashCopied(button,'LINK COPIATO ✓');setReviewStatus(card,'Link copiato. Incollalo dove vuoi condividere la build.');return}}catch(_){}
  button.textContent='COPIA…';
  if(navigator.clipboard?.writeText){navigator.clipboard.writeText(url).then(()=>{button.textContent='LINK COPIATO ✓';setReviewStatus(card,'Link copiato. Incollalo dove vuoi condividere la build.');window.setTimeout(()=>{button.textContent='CONDIVIDI BUILD'},950)}).catch(error=>{button.textContent='CONDIVIDI BUILD';setReviewStatus(card,error?.message||'Condivisione non disponibile.',true)})}
  else{button.textContent='CONDIVIDI BUILD';setReviewStatus(card,'Condivisione non disponibile.',true)}
},true);

document.addEventListener('click',event=>{if(!event.target?.closest?.(ROOT_SELECTOR))return;window.setTimeout(simplifyReviewShareCopy,0);window.setTimeout(simplifyReviewShareCopy,80)},true);

document.addEventListener('click',event=>{
  const button=event.target?.closest?.('[data-axion-copy-build],[data-axion-share-copy]');if(!button)return;
  const group=button.closest('[data-cart-group][data-axion-preview-id]');const code=group?.dataset.axionShareCode||'';if(!code)return;event.preventDefault();
  try{if(copyTextFast(code)){flashCopied(button);return}}catch(_){}
  copyText(code).then(()=>flashCopied(button)).catch(error=>console.warn('[AXION share/cart DEV]',error));
});

const run=()=>{installStyle();updateImportCopy();highlightImportBuildTrigger();simplifyReviewShareCopy();enhanceCart()};
run();if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});window.setTimeout(run,150);window.setTimeout(run,600);window.setTimeout(run,1500);
})();